import { HttpInterceptorFn } from '@angular/common/http';

const ALLOWED = ['es', 'en', 'fr', 'pt', 'it'];

/** Lee el idioma del panel sin DI (evita ciclo con TranslateService / HttpClient). */
function resolveAcceptLanguage(): string {
	const stored = localStorage.getItem('lang');
	if (stored && ALLOWED.includes(stored)) {
		return stored;
	}
	return 'es';
}

/**
 * Envía Accept-Language para localizar validaciones Laravel.
 */
export const languageInterceptor: HttpInterceptorFn = (req, next) => {
	return next(
		req.clone({
			setHeaders: {
				'Accept-Language': resolveAcceptLanguage(),
			},
		}),
	);
};
